import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from 'app/app.config';
import { LocalStorageService } from 'app/core/services/local-storage/local-storage.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'Teranet-AdminReport',
  templateUrl: './admin-report.component.html'
})
export class AdminReportComponent implements OnInit {
  Hangfireurl: string;
  url: SafeResourceUrl;
  AdminReportUrl: string;
  constructor(private cookieService: CookieService,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService) {

    this.AdminReportUrl = ((AppConfig.settings != undefined) && AppConfig.settings) ? AppConfig.settings.settings.Administrator_Url : this.localStorageService.getItem('Administrator_Url');
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.AdminReportUrl);
  }

  ngOnInit() { }
}
